import { Avatar, Box, Dropdown, Icon, Stack, Tooltip } from "prism-react";

export interface MenuItemProps
  extends React.ComponentProps<typeof Dropdown.Item> {
  as?: "a" | "button";
  href?: string;
  icon?: React.ComponentProps<typeof Icon>["type"];
  iconProps?: Omit<React.ComponentProps<typeof Icon>, "type">;
  title: string;
  tooltip?: string;
  meta?: React.ReactNode;
  avatarUrl?: string | null;
}

export const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  title,
  tooltip,
  meta,
  avatarUrl,
  iconProps,
  ...props
}) => {
  const content = (
    <Dropdown.Item {...props}>
      <Stack css={{ width: "100%" }} horizontal>
        {avatarUrl || avatarUrl === null ? (
          <Avatar name={title} shape="block" size="xs" src={avatarUrl} />
        ) : null}
        {icon ? <Icon size={4} type={icon} {...iconProps} /> : null}
        <span>{title}</span>
        {meta && <Box css={{ marginLeft: "auto" }}>{meta}</Box>}
      </Stack>
    </Dropdown.Item>
  );

  return tooltip ? (
    <Tooltip content={tooltip} asChild>
      {content}
    </Tooltip>
  ) : (
    content
  );
};
